import React from 'react';
import s from './addStudent.module.css';

// Step 4: two things a teacher plausibly wants next, both of them built.

export default function ConfirmationStep({ onScheduleLesson, onViewProfile }) {
  const next = [
    {
      title: 'Schedule a Lesson',
      desc: "Add student's first lesson to the calendar to get started.",
      go: onScheduleLesson,
    },
    {
      title: 'View Student Profile',
      desc: 'Review and manage their information.',
      go: onViewProfile,
    },
  ];

  return (
    <div className={s.done}>
      <div className={s.doneTick}>✓</div>
      <div className={s.doneTitle}>Student Added!</div>
      <div className={s.doneList}>
        <div className={s.doneEyebrow}>Optional</div>
        {next.map((c) => (
          <button key={c.title} className={s.nextCard} onClick={c.go}>
            <div className={s.nextTitle}>{c.title}</div>
            <div className={s.nextDesc}>{c.desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
